var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner-wrapper",attrs:{"data-component-name":"spinner"}},[_c('div',{staticClass:"spinner"},_vm._l(((1, 12)),function(i,index){return _c('div',{key:index,class:'bar'+i})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }